module.exports = __webpack_public_path__ + "static/media/ruben01.757341b5.jpg";